import PaymentPlanEstimator from "@/components/paymentplan/PaymentPlanEstimator"
import PaymentPlanImage from "@/components/paymentplan/PaymentPlanImage"
import PaymentPlanOption from "@/components/paymentplan/PaymentPlanOption"
import PaymentPlanMonthlyPayment from "@/components/paymentplan/PaymentPlanMonthlyPayment"
import PaymentPlanFilters from "@/components/paymentplan/PaymentPlanFilters"

export default {
    install(Vue) {
        Vue.component("PaymentPlanFilters", PaymentPlanFilters)
        Vue.component("PaymentPlanEstimator", PaymentPlanEstimator)
        Vue.component("PaymentPlanImage", PaymentPlanImage)
        Vue.component("PaymentPlanOption", PaymentPlanOption)
        Vue.component("PaymentPlanMonthlyPayment", PaymentPlanMonthlyPayment)
    },
}
